// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__ZrExl","info":"UpdateTermsInfo_info__1vl-b"};